var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[_c('div'),_c('div',{staticClass:"chart-head"},[_vm._v(" "+_vm._s(_vm.filedName)+" ")]),_c('div',{staticClass:"chart-cont"},[_c('div',{staticClass:"yName"},[_vm._v(_vm._s(_vm.yName))]),_c('div',{style:({ width: '100%', height: '100%' }),attrs:{"id":`${_vm.info.chartId}`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }